import React from 'react';
import { FormattedMessage } from 'react-intl';
import config from 'appconfig';
import { StyledLink } from '../StyledComponents';
import { StyledPipe } from './StyledPipe';

export const UpgradeLink = ({
  accountId,
  productPackageKey,
}: {
  accountId: number;
  productPackageKey: string;
}) => (
  <>
    <StyledLink
      href={`${config.root}/upgrade?accountId=${accountId}&productKey=${productPackageKey}`}
      data-cy="actions-section-upgrade-button"
    >
      <FormattedMessage id="mac.licenses.upgrade" defaultMessage="Upgrade" />
    </StyledLink>
    <StyledPipe />
  </>
);
